import React from 'react';
import HotProductsList from '../HotProductsList'
import './index.scss'
import arrowIcon from '../../assets/image/go3@3x.png'
// import api from '../../service/api';
// import utils from 'bxl-utils';
import { openAppStore } from '@/lib/appstore';

const HotProducts = function (props) {
    let {products, lookMoreLink,toProductDetail, footer} = props;
    let lookMore = () => {
        openAppStore()
    }
    return (
        <div className='hotProducts'>
            <div className='recommendTitleBox'>
                <span className='spot'></span>
                <span className='spot'></span>
                <h2 className='recommendTitle'>{products.title||'热卖商品'}</h2>
                <span className='spot spot3'></span>
                <span className='spot'></span>
            </div>
            <HotProductsList products={products.contents} toProductDetail={toProductDetail}/>
            <div className='article_lookMore' onClick={lookMore}>
                <span>{ footer.title || '查看更多' }</span>
                <img src={arrowIcon} className='article_lookMore_image' alt='arrow icon'></img>
            </div>
        </div>
    )
}

export default HotProducts;